/* eslint-disable import/no-dynamic-require */
import React, { useState, useEffect, useRef } from 'react';
import intlTelInput from 'intl-tel-input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import 'intl-tel-input/build/css/intlTelInput.css';

import './iti.css';
import styles from './InputPhone.module.css';
import stylesInput from '../shared/Input.module.css';

interface Props {
  phone: string,
  setPhone: (e: React.ChangeEvent<HTMLInputElement>) => void,
  required?: boolean,
  label: string,
  setError: (value: boolean) => void,
  dataCy?: string
}

export default function InputPhone({ phone, setPhone, required, label, setError, dataCy }: Props) {
  const [value, setValue] = useState(phone || '');
  const [isValidPhone, setIsValidPhone] = useState(true);
  const [phoneIti, setPhoneIti] = useState<any>(null);
  const phoneRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (phoneRef.current && !phoneIti) {
      const iti = intlTelInput(phoneRef.current, {
        initialCountry: 'fr',
        autoPlaceholder: 'aggressive',
        formatOnDisplay: true,
        separateDialCode: true,
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@20.0.3/build/js/utils.js',
      });
      setPhoneIti(iti);
    }

    if (phone && value === '' && phoneIti) {
      phoneIti.setNumber(phone);
      const dialCode = phoneIti.getSelectedCountryData().dialCode;
      if (dialCode) {
        setValue(phone.replace(`+${dialCode}`, ''));
      } else {
        setValue(phone);
      }
    }
  }, [value, phoneRef, phone]);

  return (
    <div>
      <p
        className={stylesInput.label}
      >
        {(required) && (<span className={styles.required}> * </span>)}
        {label}
      </p>
      <div className={`${stylesInput.input} ${styles.inputPhoneContainer}`}>
        <input
          ref={phoneRef}
          className={styles.phoneInput}
          type="tel"
          id="phone"
          name="phone"
          data-cy={dataCy}
          value={value || ''}
          onKeyUp={(e) => {
            setValue((e.target as HTMLInputElement).value);
            setPhone(phoneIti.getNumber());
            setIsValidPhone(true);
            if (setError) setError(!phoneIti.isValidNumber());
          }}
          onBlur={() => {
            if (phoneIti !== null) {
              if (phoneIti.isValidNumber()) {
                setIsValidPhone(true);
                if (setError) setError(!phoneIti.isValidNumber());
              } else {
                setIsValidPhone(false);
                if (setError) setError(true);
              }
            }
          }}
        />
      </div>
      {
        (!isValidPhone)
        &&
        <p className={`${stylesInput.hint} ${styles.error}`}>
          <FontAwesomeIcon className={styles.iconError} icon={faTimes} />
          Le numéro de téléphone est invalide
        </p>
      }
    </div>
  );
}
